import { connect } from 'react-redux';

import { getCurrencyCode, getIsHotelOnly } from 'src/store/view/selectors';

import { getTouristsCount } from 'src/routes/SearchPage/selectors/searchParams';
import { getPlainFilters } from 'src/routes/SearchPage/selectors/filters';
import {
  hasResults,
  isSearchCompleteSelector,
  hasNewResults,
} from 'src/routes/SearchPage/searchStatus/selectors';

import {
  changeFilterAction,
  clearFilterAction,
} from 'src/routes/SearchPage/actions/filters';
import { isEmptySearchSelector } from 'src/routes/SearchPage/store/emptySearch/selectors';

import { isMobileHotelFilterOpenedSelector } from 'src/routes/SearchPage/selectors/filtersBase';
import { filtersPrioritySelector } from 'src/routes/SearchPage/selectors/view';

import { FiltersPanel } from './FiltersPanel';

const mapStateToProps = (state) => ({
  filters: getPlainFilters(state),
  filtersPriority: filtersPrioritySelector(state),
  hasSearchResults: hasResults(state),
  isEmptySearch: isEmptySearchSelector(state),
  searchComplete: isSearchCompleteSelector(state),
  touristsCount: getTouristsCount(state),
  hasAwaitNewResults: hasNewResults(state),
  isHotelOnly: getIsHotelOnly(state),
  currencyCode: getCurrencyCode(state),
  mobileHotelFilter: isMobileHotelFilterOpenedSelector(state),
});

const mapDispatchToProps = {
  changeFilter: changeFilterAction,
  clearFilter: clearFilterAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersPanel);
